import { render } from "./DashboardLayout.vue?vue&type=template&id=9fdd6d64"
import script from "./DashboardLayout.vue?vue&type=script&lang=js"
export * from "./DashboardLayout.vue?vue&type=script&lang=js"

import "./DashboardLayout.vue?vue&type=style&index=0&id=9fdd6d64&lang=scss"
script.render = render

export default script